import { useParams } from "react-router-dom";
import { isTaskAssignment } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { AssignmentTaskPage } from "./AssignmentTaskPage";

const AssignmentTask = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskAssignment(currentTask) || !currentPoint) {
        return <NotFound />;
    }

    return <AssignmentTaskPage task={currentTask} point={currentPoint} />;
};

export default AssignmentTask;
